
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.64 10.95c.134-.382.21-.8.21-1.236 0-1.893-1.41-3.428-3.15-3.428-.646 0-1.25.214-1.749.578C13.042 5.15 11.346 4 9.4 4 6.5 4 4.15 6.557 4.15 9.714c0 .097.003.193.007.29C2.319 10.707 1 12.614 1 14.857 1 17.697 3.116 20 5.725 20H17.8c2.32 0 4.2-2.046 4.2-4.571 0-2.211-1.444-4.058-3.36-4.479zm-4.732 2.193h-2.146v4c0 .314-.236.571-.524.571H9.663c-.29 0-.526-.257-.526-.571v-4H6.992c-.47 0-.703-.614-.371-.975l3.458-3.764a.497.497 0 01.742 0l3.458 3.764c.332.36.095.975-.37.975z","fill":"#282E3E"}})])
          )
        }
      }
    